export default __webpack_public_path__ + "static/media/nav-arrow-up.a7898e54.svg";